(function () {
    angular.module('tmx-app').controller('lookupManagementCtrl', ['$state','$mdMedia', '$mdSidenav', 'tmxUtility','menu','LookupManagementService',

        function LookupManagementCtrl($state,$mdMedia, $mdSidenav, tmxUtility,menu,LookupManagementService) {
            //#region  =========== Variable Initialization ================
            var lookupVM = this;
            var exists = tmxUtility.exists;
            var copy = tmxUtility.copy;
            lookupVM.checkPermission = tmxUtility.checkPermission;
            lookupVM.onChildState = onChildState;
            lookupVM.isOpen = isOpen;
            lookupVM.toggleSearch = toggleSearch;
            lookupVM.toggleExport = toggleExport;
            lookupVM.toggle = toggle;
            lookupVM.menu=menu;
            lookupVM.isFiltered = isFiltered;
            lookupVM.searchSideNavActive=false;
            lookupVM.exportSideNavActive=false;
            lookupVM.search=search;
            lookupVM.clear=clear;
            lookupVM.cols = LookupManagementService.gridColumn;


            lookupVM.viewPermission = lookupVM.checkPermission("administration.lookupmanagement.info") ;
            lookupVM.editPermission = lookupVM.checkPermission("Private.Masterdata.LookupManagement","Edit") ;
            //#endregion


            //#region ============= Local Functions ============================

            function onChildState() {
                if ($state.current.name.indexOf(".add") > 0 || $state.current.name.indexOf(".edit") > 0)
                    return true;
                else
                    return false;
            }
            function isOpen(navID) {
                return $mdSidenav(navID).isOpen();
            }

            function toggleSearch() {
                if (lookupVM.searchSideNavActive) {
                    lookupVM.searchData = {};
                    lookupVM.searchSideNavActive = false;
                }
                else
                    lookupVM.searchSideNavActive = true;
                lookupVM.toggle('SearchSideNav');
            }


            function toggleExport() {
                if (lookupVM.exportSideNavActive)
                    lookupVM.exportSideNavActive = false;
                else
                    lookupVM.exportSideNavActive = true;
                lookupVM.toggle('ExportSideNav');
            }

            function toggle(navID) {
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {
                    });
            }

            function isFiltered(fieldName){
                var filtered = false;
        
                if(angular.isDefined(lookupVM.filters)){
                    lookupVM.filters.filters.forEach(function(filter){
                        if(filter.field==fieldName)
                            filtered = true;
                    });
                }
                return filtered;
            }

            function search (navID) {
                var calls=[];
                for (var key in lookupVM.searchData) {
                    if (lookupVM.searchData.hasOwnProperty(key)) {
                        calls.push({
                            field: key,
                            operator: "contains",
                            value: lookupVM.searchData[key]
                        });
                    }
                }
         
                lookupVM.filt = {
                    filters: calls,
                    logic: "and"
                };
               
                lookupVM.o.data.filter = lookupVM.filt;
                lookupVM.container.LookupGrid.dataSource.transport.read(lookupVM.o);
         
                lookupVM.searchData = {};
                lookupVM.toggle(navID);
            }
         
            function clear (navID) {
                lookupVM.searchData = {};
                lookupVM.toggle(navID);
            }

            //#endregion

            //#region ========= Scope Functions ==========================

            lookupVM.clickEdit = function(item){
                if(lookupVM.editPermission) {
                    $state.data.LookupType = item.LookupType;                   
                    $state.go($state.current.name + ".edit", {"Id": item.LookupType});
                }
            }

            //#endregion

            //#region =========== Grid Initializtion======================

            function InitializeGrid(){
                lookupVM.mainGridOptions = {
                    dataSource: {
            
                        transport: {
                            read: function(o){
                                if(angular.isDefined(lookupVM.searchClear) && lookupVM.searchClear==false){
                                    if(exists(lookupVM.o)){
                                        copy(lookupVM.o.data,["filter"],o.data);
                                    }
                                }
                                lookupVM.searchClear = false;
                                if(lookupVM.onChildState()){
                                    return;
                                }
                                if(!o.fromSideNav) {
                                    if($state.searchClear){
                                        lookupVM.searchClear = true;
                                        $state.searchClear=undefined;
                                      
                                    }
                                  
                                }
                                else{
                                    o.data.firstPage = true;
                                }
                                lookupVM.o = angular.copy(o);
                                lookupVM.filters = lookupVM.o.data.filter;
                                LookupManagementService.getByParams(o,true,'/DistinctLookupTypes').then(function(response){
                                   
                                    for(var i=0; i<response.data.length; i++){
                                        if(response.data[i].LookupType==null)
                                            response.data[i].LookupType="N/A";
                                        if(response.data[i].UserEditable){
                                            response.data[i].LookupCategory = "Application";
                                        } 
                                        else{
                                            response.data[i].LookupCategory = "System";
                                        }
                                    }
                                      
                                    if(response.data.length==0) {
                                        lookupVM.no_records = true;
                                    }
                                    else {
                                        lookupVM.no_records = false;
                                    }
                                    o.success(response);
                                });
                            },
            
                            dataType: "json"
                        },
                        schema: {
                            data: "data",
                            total: "Total"
                        },
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                        sort:  [{field: "LookupType", dir: "asc"}]
            
                        // sort:  [{field: "EffectiveEndDate", dir: "desc"}],
                    },
                    // selectable: "multiple, row",
                    pageable: {
                        refresh: true,
                        pageSizes: [5,10,15,20,100,'All'],
                        pageSize: 20,
                        buttonCount: 5
                    },
                    pdf: {
                        allPages: true,
                        fileName: "List of Values.pdf"
                    },
                    excel: {
                        allPages: true,
                        fileName: "List of Values.xlsx"
                    },
                    excelExport: function(e) {
                        var columns = e.workbook.sheets[0].columns;
                        columns.forEach(function(column){
                            delete column.width;
                            column.autoWidth = true;
                        });
                    },
                    // filterable:true,
                    // sortable: true,
                    sortable:true,
                    scrollable: !$mdMedia('gt-sm'),
                    rowTemplate: "<tr data-uid='#= uid #' >" +
                  "<td>" +
                  "<md-button ng-disabled='!LookupManagementCtrl.editPermission' class='tmx-primary-text-grid'  ng-click='LookupManagementCtrl.clickEdit(dataItem)'>{{dataItem.LookupType}} </td>" +
                  "<td class='grid-col' > {{dataItem.LookupCategory}}   </td>" +
            
            
                  "<td  class='grid-col'>" +
                  "<md-menu flex='none' class='menu-list-item' md-offset='24 60'>"+
                  "<md-button  class='menu-list-item-grid' ng-click='$mdOpenMenu()'><md-icon class='menu-list-item material-icons'>more_vert</md-icon>" + "</md-button><md-menu-content width='2' >" +
                  "<md-menu-item ng-hide='!LookupManagementCtrl.editPermission'>" +
                  "<md-button  aria-label='del' ng-disabled='!LookupManagementCtrl.editPermission' class='tmxMin' ng-click='LookupManagementCtrl.clickEdit(dataItem)'> " +
                  "<md-icon class='md-accent material-icons menu-list-item'>edit</md-icon> {{'Edit'|translate}}" +
                  "</md-button>"+
                  "</md-menu-item>"+
                  "<md-menu-item>" +
                  "<md-button  aria-label='del' class='tmxMin' ng-disabled='!LookupManagementCtrl.viewPermission' ng-click='LookupManagementCtrl.clickView(dataItem)'>" +
                  "<md-icon class='md-accent material-icons menu-list-item'>info</md-icon> {{'Info'|translate}}</md-button>" +
                  "</md-menu-item>" +                  
                  "</md-menu-content></md-menu></td></tr>",            
                    columns: LookupManagementService.columns
                };
            
                $state.data={
                    // groupable: true,
                    grid: lookupVM.container,
                    info: false
            
                };
            }
            //#endregion

            (function InitializePage(){
                InitializeGrid();
            })();
        }]);
})();
